import { render } from "./IntakeForms.vue?vue&type=template&id=e009ad78&scoped=true"
import script from "./IntakeForms.vue?vue&type=script&lang=js"
export * from "./IntakeForms.vue?vue&type=script&lang=js"

import "./IntakeForms.vue?vue&type=style&index=0&id=e009ad78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e009ad78"]])

export default __exports__